import React from "react";
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import "./arrow.css";

export interface IArrowProps {
  className?: string, 
  onClick?: () => void, 
}

export function NextArrow( props: IArrowProps ) {
  const { className, onClick } = props;
  return (
    <div
      className={className}
      onClick={onClick}
    >
      <ArrowRightIcon fontSize='large' />
    </div>
  );
}

export function PrevArrow( props: IArrowProps ) {
  const { className, onClick } = props;
  return (
    <div
      className={className}
      onClick={onClick}
    >
      <ArrowLeftIcon fontSize='large' />
    </div>
  );
}